import React, { useState } from 'react'
import { Box, Button, Divider, Select } from '@chakra-ui/core'
import dayjs from 'dayjs'
import { setRemoteCall } from '../../../remote'
import { useGlobalState, getGlobalState } from '../../../store'

const ChangeProject = (props) => {
  const { data, relataion, column, setView, setOpen } = props
  const [selectedProject, setSelectedProject] = useState(null)
  const projects = getGlobalState('projects')
  //Remove resource from project
  const moveResourceToProject = (e) => {
    const thisProjects = projects.find((prj) => prj._id === selectedProject)
    //then we can add the new relation
    //sanaty check, lest only count if the selected project is different than relation
    if (!selectedProject || selectedProject === relataion.projectId) {
      return
    }

    setRemoteCall(
      'setRelationToProject',
      {
        dateStart: column?.date,
        dateEnd:
          thisProjects && dayjs(thisProjects.endDate).format('DD/MM/YYYY'),
        projectId: selectedProject,
        accountId: relataion?.accountId,
        resource: data,
        sort: 1,
      },
      null
    )
    setView(null)
    setOpen(false)
  }

  return (
    <>
      <Select
        size={'sm'}
        placeholder="Selecione uma obra"
        onChange={(e) => setSelectedProject(e.target.value)}
      >
        {projects.map((project) => (
          <option key={project._id} value={project._id}>
            {project?.code} - {project.name}
          </option>
        ))}
      </Select>
      <Button
        size="sm"
        w={'100%'}
        mt={2}
        onClick={() => moveResourceToProject()}
        className="actionsButton"
        variantColor="red"
        variant="outline"
      >
        <i className="icons icon-share-alt" style={{ marginRight: '4px' }} />
        Mover para obra
      </Button>
      <Button
        w={'100%'}
        size="sm"
        fontSize={'.8em'}
        onClick={() => setView(null)}
        variant="outline"
      >
        Cancelar
      </Button>
    </>
  )
}

export default ChangeProject
